import React from "react";
import { hinweisen } from "../../redesign/bestaetigen";

/**
 * T-243 — „Gibt es keine Rechtschreibprüfung bei den Mails?"
 *
 * KMVS hat keine eigene Prüf-Engine: Geprüft wird vom Browser (in Edge über
 * die Windows-Rechtschreibprüfung). Der Editor schaltet sie ausdrücklich auf
 * Deutsch ein; ob sie wirkt, hängt aber an den Edge-Einstellungen. Diese
 * Anleitung erklärt das — Nutzer ohne Technikwissen finden den Weg in die
 * Edge-Einstellungen sonst nicht.
 */
export const RECHTSCHREIB_HILFE_TITEL = "Rechtschreibprüfung – Hilfe";

const schritt: React.CSSProperties = { margin: "0 0 10px" };

export const RechtschreibHilfeText: React.FC = () => (
    <div style={{ textAlign: "left", lineHeight: 1.5 }}>
        <p style={schritt}>
            Falsch geschriebene Wörter werden beim Tippen <strong>rot unterstrichen</strong>. Ein{" "}
            <strong>Rechtsklick</strong> auf das Wort zeigt Korrekturvorschläge.
        </p>
        <p style={schritt}>
            <strong>Keine roten Linien?</strong> Dann ist die Prüfung in Edge ausgeschaltet. So schalten Sie
            sie ein: In Edge oben rechts auf <strong>„…“</strong> → <strong>Einstellungen</strong> →{" "}
            <strong>Sprachen</strong> (oder <code>edge://settings/languages</code> in die Adressleiste
            eingeben). Dort <strong>„Rechtschreibung prüfen“</strong> bzw. <strong>„Schreibunterstützung“</strong>{" "}
            einschalten und <strong>Deutsch</strong> als Sprache für die Rechtschreibprüfung aktivieren.
        </p>
        <p style={{ margin: 0 }}>
            Hinweis: Zitierter Text aus der Ursprungsmail und eingefügte Vorlagen werden erst geprüft, wenn
            Sie darin schreiben.
        </p>
    </div>
);

/** Öffnet die Anleitung als eigenes KMVS-Popup (kein Browser-Dialog). */
export const zeigeRechtschreibHilfe = (): Promise<void> =>
    hinweisen({ titel: "Rechtschreibprüfung", text: <RechtschreibHilfeText />, ok: "Schließen" });

/** Titel des Knopfs bei aktiver eigener Prüfung. */
export const rechtschreibKnopfTitel = (anzahl: number): string =>
    anzahl === 0
        ? "Rechtschreibprüfung – keine Hinweise"
        : `Rechtschreibprüfung – ${anzahl} ${anzahl === 1 ? "Hinweis" : "Hinweise"} (zum ersten springen)`;

/** Erklärung der eigenen Prüfung (T-243), wenn gerade nichts offen ist. */
export const zeigeRechtschreibHilfeAktiv = (): Promise<void> =>
    hinweisen({
        titel: "Rechtschreibprüfung",
        text: (
            <div style={{ textAlign: "left", lineHeight: 1.5 }}>
                <p style={schritt}>Im Moment ist nichts zu beanstanden.</p>
                <p style={schritt}>
                    Während Sie schreiben, prüft KMVS den Text: <strong>rot gewellt</strong> heißt
                    Rechtschreibung, <strong>blau gewellt</strong> Grammatik oder Zeichensetzung. Ein{" "}
                    <strong>Klick</strong> (oder Rechtsklick) auf die markierte Stelle zeigt Vorschläge; „Ignorieren“ blendet den
                    Hinweis für diese Mail aus.
                </p>
                <p style={{ margin: 0 }}>
                    Zitierter Text aus der Ursprungsmail und die Signatur werden nicht geprüft.
                </p>
            </div>
        ),
        ok: "Schließen",
    });

/** Symbol „ABC mit Haken" — passt neben die Fluent- und die kvp-Icons. */
export const RechtschreibIcon: React.FC = () => (
    <svg width="18" height="18" viewBox="0 0 20 20" aria-hidden fill="none" stroke="currentColor" strokeWidth={1.4}>
        <text x="1" y="9" fontSize="8" fontFamily="Segoe UI, sans-serif" fill="currentColor" stroke="none" fontWeight={600}>
            ABC
        </text>
        <path d="M6 14.5l2.5 2.5L15 10.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
